class AdRequestCookieManager {
  public guid = "";
  public omgid = "";
  public platformVersion = "";
  public versionName = "";
  public versionCode = "";
  public channelId = "";
  public bucketId = "";
  public qimei = "";
  public qimei36 = "";
  public imei = "";
  public imsi = "";
  public dpi = "";
  private data: Record<string, string> | null = null;

  constructor() {}

  public getData() {
    if (!this.data) {
      this.readCookie();
    }
    return this.data ?? {};
  }

  public getUUID() {
    return this.data?.video_guid ?? "";
  }

  public refresh() {
    this.readCookie();
  }

  public refreshIfNeeded() {
    if (!this.data) {
      this.readCookie();
    }
  }

  readCookie() {
    const data = this.getEVOCookie();
    this.guid = data.guid || "";
    this.omgid = data.omgId || "";
    this.qimei = data.qimei || "";
    this.qimei36 = data.qimei36 || "";
    this.platformVersion = data.platformVersion || "";
    this.versionName = data.versionName || "";
    this.bucketId = data.bucketId || "";
    this.data = data;
    this.imei = data.IMEI || "";
    this.imsi = data.IMSI || "";
    this.data = data;
  }

  getEVOCookie(): Record<string, string> {
    let data: Record<string, string> = {};
    if (import.meta.env.EVO && vnContext && vnContext.external) {
      data = vnContext.external.getUNRequestManagerInitializeParam();
      // console.log('[ad]getEVOCookie-getUNRequestManagerInitializeParam', data);
    }
    return data;
  }
}

export const adRequestCookieManager = new AdRequestCookieManager();
